import { UpdateVideoPayload } from "../apis/useUpdateVideo/updateVideo.types";
import { VideoFormValues } from "../components";

export const convertVideoFormDataToUpdateBody = (
  formData: VideoFormValues
): UpdateVideoPayload => ({
  id: formData.id as string,
  title: formData.title,
  description: formData.description,
  targetResellerLevel: formData.targetResellerLevel,
  isOrderTutorial: formData.isOrderTutorial,
  isWebviewTutorial: formData.isWebviewTutorial,
  videoMediaId: formData.video?.id ?? null,
  thumbnailId: formData.thumbnail?.id ?? null
});
